import React, { Component } from "react";
import "./EditProfile.css";
import UserProfile from "./UserProfile";
import ProfessionalDetails from "./ProfessionalDetails";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import { API, Auth } from "aws-amplify";
import { s3Upload } from "../libs/awsLib";



export default class ChangePassword extends Component {

validateForm(){
  return this.state.oldPassword && this.state.oldPassword.length > 0
            && this.state.newPassword && this.state.newPassword.length > 0
            && this.state.retypeNewPassword
            && this.state.newPassword === this.state.retypeNewPassword;

}

constructor(props){
  super(props);

  this.state = {
      isLoading: false,
      errorMsg: "",
      oldPassword: "",
      newPassword: "",
      retypeNewPassword: ""
  };
}

handleChange = event => {
  this.setState({
    [event.target.id]: event.target.value,
    errorMsg: ""
  });

}

submitChangePassword = async event => {
    event.preventDefault();

    if(this.state.oldPassword.length === 0){
      this.setState({errorMsg: "Please enter your old password"});
      return;
    }

    if(this.state.newPassword.length < 8){
      this.setState({errorMsg: "Your password should be minimum 8 characters"});
      return;
    }

    if(this.state.newPassword !== this.state.retypeNewPassword){
      this.setState({errorMsg: "New Password and Retype New Password DO NOT Match."});
      return;
    }

    try{
        this.setState({ isLoading: true});
        await this.changePassword();
        this.setState({isLoading: false});
        this.props.logoutHandler();

    }catch(e){
      this.setState({isLoading: false, errorMsg: e.message});
    }
 }

  async changePassword(){
    var user = await Auth.currentAuthenticatedUser();
    var retValue = await Auth.changePassword(user, this.state.oldPassword, this.state.newPassword);
  }

  getErrorElement(){
     return this.state.errorMsg && this.state.errorMsg.length > 0
                             ? <div className="alert alert-danger" role="alert">
                                 {this.state.errorMsg}
                               </div>
                             : "";
  }

render() {
    return(
      <div className="container">
            <br />
            <div className="row cols-xs-space cols-sm-space cols-md-space">
                  <div className="col-lg-12">
                    <div className="row">
                       <div className="col-lg-2"></div>

                       <div className="col-lg-8 profile-udpate-widget">
                          <div className="card">
                              <div className="card-title b-xs-bottom">
                                  <h3 className="heading heading-sm text-uppercase">Change Password</h3>

                              </div>
                              <div className="card-body">
                                  <div className="row">
                                      <div className="col-sm-12">
                                          <form id="personal-details-form"
                                              onSubmit={this.submitChangePassword}>
                                              <div className="form-group">
                                                  <label htmlFor="oldPassword">Old Password</label>
                                                  <input type="password" id="oldPassword"
                                                       className="form-control"
                                                       placeholder=""
                                                       onChange={this.handleChange} />
                                              </div>
                                              <div className="form-group">
                                                  <label htmlFor="newPassword">New Password</label>
                                                  <input type="password" id="newPassword"
                                                       className="form-control"
                                                       onChange={this.handleChange} />
                                              </div>
                                              <div className="form-group">
                                                  <label htmlFor="retypeNewPassword">Retype New Password</label>
                                                  <input type="password" id="retypeNewPassword"
                                                       className="form-control"
                                                       onChange={this.handleChange} />
                                              </div>

                                              <br />
                                              <div className="form-group align-center">

                                                  <LoaderButton block="true"
                                                        disabled={!this.validateForm()} type="submit"
                                                        isLoading={this.state.isLoading} text=" Update "
                                                        loadingText="Updating Password..."
                                                        className="btn btn-primary"/>
                                              </div>

                                          </form>

                                           {this.getErrorElement()}
                                      </div>
                                  </div>
                              </div>
                          </div>
                       </div>

                       <div className="col-lg-2"></div>
                    </div>
                  </div>
            </div>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ChangePassword.js